import { Data } from '@blade/std-lib'

import type { PlatformUtilType } from './platform-util-type'

export class PlatformError extends Data.TaggedError('PlatformError')<{
  platform: PlatformUtilType
  method: string
  cause: unknown
}> {}
